import { Abas } from "./Abas";

export default Abas;